<template>
  <div class="dropdown is-hoverable is-right" :class="$style.container">
    <b-dropdown hoverable aria-role="list" class="is-right">
      <b-button
        type="is-info"
        size="is-small"
        :class="$style.navDropdownTrigger"
        slot="trigger"
        >{{ nameInitial.toUpperCase() }}</b-button
      >

      <div :class="$style.userInfo" v-if="userName && userEmail">
        <p :class="$style.userInfoPrimary">{{ userName }}</p>
        <p :class="$style.userInfoSecondary">{{ userEmail }}</p>
      </div>
      <div :class="$style.userInfo" v-else-if="userName || userEmail">
        <p :class="$style.userInfoPrimary">{{ userName || userEmail }}</p>
      </div>

      <template v-for="(link, i) in navLinks">
        <div
          :class="i === 0 ? '' : $style.navLinkSection"
          :key="i + '' + link.length"
        >
          <router-link
            v-if="link.to"
            aria-role="listitem"
            :key="link.name + link.url"
            @click="link.onClick() || undefined"
            :to="link.to"
            class="dropdown-item"
            :class="link.class"
            >{{ link.label }}</router-link
          >
          <a
            v-else
            aria-role="listitem"
            :key="link.name + link.url"
            @click="link.onClick() || undefined"
            :href="link.url || false"
            class="dropdown-item"
            :class="link.class"
            >{{ link.label }}</a
          >
        </div>
      </template>
    </b-dropdown>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { NavLink } from '../types/Nav';
import { get as _get } from 'lodash';

@Component({})
export default class BaseNavDropdown extends Vue {
  @Prop(String) public userName!: string;
  @Prop(String) public userEmail!: string;
  @Prop({ type: Array, required: true })
  public navLinks!: NavLink[][];

  get nameInitial(): string {
    return _get(this.userName, 0) || _get(this.userEmail, 0) || 'U';
  }
}
</script>

<style lang="scss" module>
.container {
  :global {
    .dropdown-content {
      padding: 0;
      width: 100%;
    }

    .dropdown-item {
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .dropdown-menu {
      // Invisible bridge above the dropdown to prevent hover gap
      &::before {
        content: '';
        display: block;
        position: absolute;
        bottom: 100%;
        left: 0;
        right: 0;
        height: 16px;
      }
    }
  }
}

.navLinkSection {
  border-top: 1px solid $grey-border;
}

.navDropdownTrigger {
  &#{&}#{&}#{&}#{&} {
    font-size: 20px;
    text-align: center;
    border-radius: 100%;
    background-color: $primary;
    width: 42px;
    height: 42px;
  }
}

.userInfo {
  border-bottom: 1px solid $grey-border;
  padding: 10px 16px 10px;

  .userInfoPrimary {
    color: $grey;
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .userInfoSecondary {
    color: $grey;
    font-size: 12px;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
